import api from "api"

export const publishForm = async (id) => {
  const { data } = await api.post(
    `/form/publish/${id}`
  );

  return data;
}